var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 9.87565V6.12427C9.33301 4.02747 9.33301 2.97907 8.71613 2.71816C8.09925 2.45725 7.37324 3.19858 5.92122 4.68124C5.16927 5.44906 4.74024 5.61908 3.67037 5.61908C2.73472 5.61908 2.2669 5.61908 1.93084 5.84837C1.23324 6.32433 1.33869 7.25462 1.33869 7.99996C1.33869 8.7453 1.23324 9.67559 1.93084 10.1515C2.2669 10.3808 2.73472 10.3808 3.67037 10.3808C4.74024 10.3808 5.16926 10.5509 5.92122 11.3187C7.37324 12.8013 8.09925 13.5427 8.71613 13.2818C9.33301 13.0208 9.33301 11.9725 9.33301 9.87565Z",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 6C11.7499 6.54645 11.9997 7.24229 11.9997 8C11.9997 8.75771 11.7499 9.45355 11.333 10",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 4.66663C14.1669 5.57738 14.6663 6.73712 14.6663 7.99996C14.6663 9.2628 14.1669 10.4225 13.333 11.3333",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolume);
export default __webpack_public_path__ + "static/media/icon-volume.458db5b939518de17c1b5ba215ce45c1.svg";
export { ForwardRef as ReactComponent };